<template>
  <div class="homepage-destinations">
    <div class="des-content">
      <div class="main-title">
        <h2 class="title">精选目的地</h2>
        <h3 class="subtitle">从亚洲到全球，超时空之旅</h3>
      </div>
      <div class="img-area">
        <div
          class="wrap"
          v-for="(destination, i) in destinations"
          :key="'destination_' + i"
          :class="{ video: isVideo(destination) || destination.video === 'empty' }"
        >
          <div v-if="!isVideo(destination) || destination.video === 'empty'">
          <img :src="destination.pcImage" alt="" />
            <div class="des-name">
              <span class="cn">{{ destination.destinationName }}</span
              ><span class="en">{{ destination.destinationENName }}</span>
            </div>
            <div class="bg-mask"></div>
            <div class="mask">
              <div class="intro">
                {{ destination.description }}
              </div>
              <div v-if="destination.hotCity && destination.hotCity.length > 0" class="intro">热门目的地：{{ destination.hotCity }}</div>
              <div class="btn-area">
                <a
                  class="search-more"
                  :href="destination.pcLink"
                  target="_blank"
									@click="gioTrackDes(destination.code, destination.pcLink)"
                  >查看全部目的地</a
                >
              </div>
            </div>
          </div>
          <div v-else @click="onVideoClick(destination)">
            <div class="v-wrap">
              <img :src="destination.pcImage" />
            </div>
            <div class="mask"></div>
          </div>
        </div>
      </div>
    </div>
    <VideoModel
      :isShow="isShowVideoPopup"
      :videoUrl="videoUrl"
      v-on:onModalClose="closeVideoPopup"
    />
  </div>
</template>

<script>
const VideoModel = () => import("@/components/Common/VideoModel");
import { gioAdsTracking } from "@/utilities/tools";
export default {
  name: "HomeDestination",
  components: {
    VideoModel,
  },
  props: {
    destinations: {
      type: Array,
    },
  },
  data() {
    return {
      isShowVideoPopup: false,
      videoUrl: "",
    };
  },
  methods: {
    isVideo(destination) {
      return destination.video && destination.video.length > 0;
    },
    onVideoClick(destination) {
      if (destination.video && destination.video.length > 0) {
        this.videoUrl = destination.video;
        this.isShowVideoPopup = true;
				gioAdsTracking({
					"adsType": "ch",
					"chDesVideo": "1"
				})
      }
    },
    closeVideoPopup() {
      this.isShowVideoPopup = false;
    },
		gioTrackDes(code, url) {
			gioAdsTracking({
				"adsType": "ch",
				"chDes": code,
				"desUrl": url
			})
		}
  },
};
</script>
